/* eslint-disable camelcase */
import { put, call, take } from 'redux-saga/effects'
import { getCurrentUser } from 'api/authentication'
import { setupProjectsAction, setupMobileAction, notifyHoneybadgerAction, showMobileErrorAction } from 'actions/applicationActions'
import { SETUP_MOBILE } from 'actions/applicationActionTypes'
import { setupExportAction } from 'actions/exportActions'
import { SETUP_APPLICATION } from 'actions/applicationActionTypes'
import { Honeybadger } from 'configuredModules'
import setupPusherForExports from 'helpers/setupPusherForExports'
import catchEarlyErrorsSaga from 'sagas/catchEarlyErrorsSaga'
import onMobile from 'helpers/onMobile'

function configureHoneybadger() {
  Honeybadger.configure({
    api_key: '5c51ec8b',
    environment: BETA ? 'beta' : ENV,
    onerror: ENV !== 'development',
    revision: REVISION
  })
}

export function * setupApplication() {
  try {
    const { project, stepThrough } = yield take(SETUP_APPLICATION)
    yield call(configureHoneybadger)
    if (EXPORT) {
      yield call(setupPusherForExports, project.exportId)
      // things like this need to be handled in a general setup export fn,
      // and the actual export work should be separated
      window.exportId = project.exportId
      yield put(setupExportAction(project, project.cameraDataFilename, stepThrough))
    } else {
      const { signed_in, active, camera_data_filename } = yield call(getCurrentUser)
      onMobile()
        ? yield put(setupMobileAction(!signed_in || !active, active, camera_data_filename))
        : yield put(setupProjectsAction(!signed_in || !active, active, null, camera_data_filename))
    }
  } catch (err) {
    if (onMobile()) {
      yield put(notifyHoneybadgerAction(err, { type: SETUP_MOBILE, skipThrow: true }))
      yield put(showMobileErrorAction())
    } else {
      yield call(catchEarlyErrorsSaga, err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/setupApplicationSaga.js